@if (isFetching) {
  <div class="occasion-genius-card">
    <div class="occasion-genius-card__header">
      <figure>
        <ngx-skeleton-loader [theme]="{height: '100%', width: '100%'}"></ngx-skeleton-loader>
      </figure>
      <button class="occasion-genius-card__favourite btn-hurt btn-hurt--circle">
        <mat-icon [svgIcon]="eSvgIcons.HURT"></mat-icon>
      </button>
    </div>
    <div class="occasion-genius-card__content">
      <div class="occasion-genius-card__date">
        ‎ <ngx-skeleton-loader [theme]="{height: '16px', width: '30%', margin: '0'}"></ngx-skeleton-loader>
      </div>

      <h3 #titleRef>
        ‎
        <ngx-skeleton-loader [theme]="{height: titleRef.clientHeight + 'px', width: '70%', margin: '0'}"></ngx-skeleton-loader>
      </h3>

      <div class="itinerary-card__row">
        <ngx-skeleton-loader [theme]="{height: '16px', width: '250px', margin: '0'}"></ngx-skeleton-loader>
      </div>

    </div>
    <div class="occasion-genius-card__footer">
      <button class="occasion-genius-card__read-more btn-default btn-blue">
        View
      </button>
    </div>
  </div>
} @else {
  @if (eventPreview) {
    <div class="occasion-genius-card">
      <div class="occasion-genius-card__header">
        <figure>
          <img [src]="eventPreview?.image_url | safeUrl" alt="occasion-genius-image">
        </figure>

        <div class="occasion-genius-card__favourite btn-hurt btn-hurt--circle"
             [class.active]="favoritesProviderService.isFavorite('occasion_genius', eventPreview.uuid)"
             (click)="toggleHurt($event)">
          <mat-icon [svgIcon]="eSvgIcons.HURT"></mat-icon>
        </div>
      </div>
      <div class="occasion-genius-card__content">
        <div class="occasion-genius-card__date">
          @if (events.length > 1) {
            {{ m(events[0].start_date, 'YYYY-MM-DD HH:mm:ss').format('MMM Do') }} - {{ m(events[events.length - 1].start_date, 'YYYY-MM-DD HH:mm:ss').format('MMM Do') }}
          } @else {
            {{ m(eventPreview.start_date, 'YYYY-MM-DD HH:mm:ss').format('MMM Do YYYY, h:mmA') }}
          }
        </div>
        <h3>
          {{ eventPreview.name }}
        </h3>

        <div class="occasion-genius-card__row">
          <p class="occasion-genius-card__description">
            {{eventPreview.description}}
          </p>
        </div>
      </div>
      <div class="occasion-genius-card__footer">
        <a class="occasion-genius-card__read-more btn-default btn-blue" target="_blank"
           (click)="handleShowMore($event)">
          View
        </a>
      </div>
    </div>
  }
}
